<script lang="ts" setup>
import type { VNuxtLinkTarget } from '~/components/v-nuxt-link/VNuxtLink.vue'
export interface LinkBoxProps {
    to: VNuxtLinkTo
    target?: VNuxtLinkTarget
    showArrow?: boolean
    classNames?: string
    label?: string
}

const props = withDefaults(defineProps<LinkBoxProps>(), {
    target: '_self',
    showArrow: true,
    classNames: 'rounded-4',
    label: '',
})
</script>
<template>
  <VNuxtLink
    class="link-box transition box-shadow-1 p-5 d-flex align-items-center justify-content-between fw-bold fs-bigger text-decoration-none"
    :target="props.target"
    :class="props.classNames"
    :to="props.to"
    :label="props.label"
  >
    <slot />
    <svg
      v-if="props.showArrow"
      class="flex-shrink-0 d-block ms-2 link-box-icon transition"
      width="8"
      height="16"
    >
      <use xlink:href="#angle-right" />
    </svg>
  </VNuxtLink>
</template>
<style lang="scss">
@import './LinkBox.vars.scss';
</style>
<style lang="scss" scoped>
@import './LinkBox.scss';
</style>
